import { render, staticRenderFns } from "./VuesticTreeCategory.vue?vue&type=template&id=326581d4"
import script from "./VuesticTreeCategory.vue?vue&type=script&lang=js"
export * from "./VuesticTreeCategory.vue?vue&type=script&lang=js"
import style0 from "./VuesticTreeCategory.vue?vue&type=style&index=0&id=326581d4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('326581d4')) {
      api.createRecord('326581d4', component.options)
    } else {
      api.reload('326581d4', component.options)
    }
    module.hot.accept("./VuesticTreeCategory.vue?vue&type=template&id=326581d4", function () {
      api.rerender('326581d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-tree-view/VuesticTreeCategory.vue"
export default component.exports